import React from 'react';
import { useScopedI18n } from '@locales/client';
import {
  InfoContainer,
  InfoItemContainer,
  InfoItemImg,
  InfoItemText,
  StyledImage,
} from './styles';

const iconsCashback = [
  { src: '/images/cashback/new_icons/coins.svg', key: '0' },
  { src: '/images/cashback/new_icons/thumbsup.svg', key: '1' },
  { src: '/images/cashback/new_icons/h24.svg', key: '2' },
  { src: '/images/cashback/new_icons/crown.svg', key: '3' },
  { src: '/images/cashback/new_icons/calendar.svg', key: '4' },
  { src: '/images/cashback/new_icons/withdrawal.svg', key: '5' },
];

export const InfoList = () => {
  const ct = useScopedI18n('cashback.info');
  
  return (
    <InfoContainer>
      {iconsCashback.map(({ src, key }) => (
        <InfoItemContainer key={src}>
          <InfoItemImg>
            <StyledImage src={src} />
          </InfoItemImg>
          <InfoItemText>{ct(key)}</InfoItemText>
        </InfoItemContainer>
      ))}
    </InfoContainer>
  );
};